type VaultModule = typeof import("@apideck/vault-js");

let preloadPromise: Promise<VaultModule> | null = null;

function startPreload(): Promise<VaultModule> {
  if (!preloadPromise) {
    preloadPromise = import("@apideck/vault-js").catch((err) => {
      preloadPromise = null;
      throw err;
    });
  }
  return preloadPromise;
}

startPreload();

export async function getApideckVault() {
  const mod = await startPreload();
  return mod.ApideckVault;
}
